const FETCH_CMS_MTO_REQUEST = 'FETCH_CMS_MTO_REQUEST'
const FETCH_CMS_MTO_UPDATE = 'FETCH_CMS_MTO_UPDATE'
const FETCH_CMS_DELIVERY_REQUEST = 'FETCH_CMS_DELIVERY_REQUEST'
const FETCH_CMS_DELIVERY_UPDATE = 'FETCH_CMS_DELIVERY_UPDATE'

export { FETCH_CMS_MTO_REQUEST, FETCH_CMS_MTO_UPDATE, FETCH_CMS_DELIVERY_REQUEST, FETCH_CMS_DELIVERY_UPDATE }
